import { Link, useNavigate } from 'react-router-dom'
import { useCases } from '../lib/queries'
import { PageHead, Skel, Empty } from '../components/ui'
import { money, thaiDate } from '../lib/format'

export const caseStatus: Record<string, string> = {
  open: 'เปิด', investigating: 'กำลังสอบ', pending_review: 'รออนุมัติ',
  approved: 'อนุมัติแล้ว', rejected: 'ตีกลับ', closed: 'ปิดแล้ว',
}

export function StatusChip({ status }: { status: string }) {
  const tone = status === 'approved' ? 'gold' : status === 'rejected' ? 'danger' : ''
  return <span className={`chip ${tone}`}>{caseStatus[status] ?? status}</span>
}

export function Cases() {
  const q = useCases()
  const navigate = useNavigate()
  const rows = q.data ?? []
  return (
    <>
      <PageHead title="เคสตรวจสอบ" sub="รวมข้อสังเกตเป็นเรื่องเดียว แล้วปิดด้วยการอนุมัติของมนุษย์" />
      {q.isLoading ? <Skel h={220} /> : rows.length === 0 ? (
        <Empty title="ยังไม่มีเคส" body="เปิดเคสได้จากหน้ารายละเอียดข้อสังเกต" />
      ) : (
        <div className="table-wrap">
          <table className="data">
            <thead><tr><th>เลขเคส</th><th>เรื่อง</th><th>ข้อสังเกต</th><th>มูลค่าความเสี่ยง</th><th>เปิดเมื่อ</th><th>สถานะ</th></tr></thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} onClick={() => navigate(`/cases/${c.id}`)} style={{ cursor: 'pointer' }}>
                  <td className="mono">{c.case_no}</td>
                  <td><Link to={`/cases/${c.id}`} onClick={(e) => e.stopPropagation()} style={{ color: 'inherit', textDecoration: 'none' }}>{c.title}</Link></td>
                  <td className="num dim">{c.finding_count}</td>
                  <td className="num">{c.amount_at_risk_satang > 0 ? money(c.amount_at_risk_satang) : '—'}</td>
                  <td className="dim">{thaiDate(c.opened_at)}</td>
                  <td><StatusChip status={c.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}
